<div class="row nova-font-style bottom-margin-0">
  <div class="col s12 m12 l4 xl3">
    <div class="left-container">
      <div id="history-container" filterIcons [filterRows]="filterRows" [pageIn]="'Payroll'">
        <h2>History</h2>
        <kendo-grid id=importsGrid [data]="gridView" [selectable]="selectableSettings" [scrollable]="'auto'"
          [resizable]="true" [sortable]="true" [pageable]="true" [filterable]="true" [filter]="gridState.filter"
          [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
          (dataStateChange)="onStateChange($event)" (cellClick)="cellClickHandler($event)">

          <ng-template *ngIf="operators.Add" kendoGridToolbarTemplate>
            <div class="row bottom-margin-0">
              <div class="col l12 xl12 margin-5 left-padding-0">
                <button class="btn btn-fullwidth background-red right-margin-5" id="import-from-file"
                  (click)="openPopup()"><span class='k-icon k-i-upload height-auto'></span>Import File</button>
                <button class="btn btn-fullwidth background-red" id="submit-import" *ngIf="isUnsubmittedImport"
                  [disabled]="disableSubmitBtn" (click)="displaySubmitPop();"><span
                    class='k-icon k-i-file-bac height-auto'></span>Submit Import</button>
              </div>
            </div>
          </ng-template>

          <!-- Mobile View -->
          <kendo-grid-column media="(max-width: 992.98px)" title="Details">
            <ng-template kendoGridCellTemplate let-dataItem>
              <!-- template for mobile -->
              <dl>
                <!-- Import Id -->
                <dt>
                </dt>
                <dd>
                  <div class="align-left">
                    <span class="bold">Import Id: </span>
                    <span> {{ dataItem.id }}</span>
                  </div>
                </dd>
                <!-- PPED -->
                <dt>
                </dt>
                <dd>
                  <div class="align-left">
                    <span class="bold">PPED: </span>
                    <span>{{ dataItem.pped }}</span>
                  </div>
                </dd>
                <!-- Records -->
                <dt>
                </dt>
                <dd>
                  <div class="align-left">
                    <span class="bold">Records: </span>
                    <span>{{ dataItem.records }}</span>
                  </div>
                </dd>
              </dl>
            </ng-template>
          </kendo-grid-column>

          <!-- ID COLUMN -->
          <kendo-grid-column field="id" media="(min-width: 993px)" title="Id" [width]="45">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <span
                class="{{dataItem.remittanceReconciliationId === null && dataItem.revenueControlTransmittalId === null?'warning fontChange':''}}">{{dataItem.id}}</span>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell id="search" [showOperators]="false" [column]="column" [filter]="filter"
                [spinners]="false">
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <!-- PPED COLUMN -->
          <kendo-grid-column field="pped" media="(min-width: 993px)" title="PPED" [width]="60"
            [headerClass]="{'align-date': true}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-date">
                <span>
                  {{dataItem.pped}}
                </span>
              </div>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell class="kfilter" [placeholder]="'Search'" [showOperators]="false"
                [column]="column" [filter]="filter">
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <!-- RECORDS COLUMN -->
          <kendo-grid-column field="records" media="(min-width: 993px)" title="Records" [width]="35" [filterable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-number">{{dataItem.records}}</div>
            </ng-template>
          </kendo-grid-column>

          <!-- CLONE AND DELETE COLUMN -->
          <kendo-grid-column title="" [width]="45" media="(min-width: 993px)" class="align-center"
            *ngIf="operators.Add || operators.Delete">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <div class="align-center" kendoTooltip>
                <a (click)="clone(dataItem.id);" *ngIf="!isImportProcessed(dataItem) && operators.Add"
                  data-id={{dataItem.id}} id="cloneImport">
                  <span class="k-icon k-i-copy link-icon" title="Clone"></span>
                </a>
                <a (click)="delete(dataItem.id, dataItem.invoiceId);"
                  *ngIf="(dataItem.paymentStatus === 1 || dataItem.paymentStatus === 0 ) && operators.Delete"
                  data-id={{dataItem.id}} id="deleteImport">
                  <span class="k-icon k-i-delete link-icon" title="Delete"></span>
                </a>
              </div>
            </ng-template>
          </kendo-grid-column>

          <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-info></kendo-pager-info>
          </ng-template>

        </kendo-grid>
      </div>
      <div class="common-stroke-separator" id="stroke-separator"></div>
      <!-- PAYROLL SUMMARY -->
      <app-payroll-summary [payrollRecordsGrid]="payrollRecordsGrid" [import]="selectedImport"
        (isError)="importError($event)"></app-payroll-summary>
    </div>
  </div>
  <div class="col s12 m12 l8 xl9" id="payroll-grid">
    <div class="right-container">
      <div class="col xs12 s12 m12 l12 xl12" id="payroll-grid">
        <h2 class="alignLeft">Payroll Records</h2>
        <!-- PAYROLL RECORD -->
        <app-payroll-record #payrollRecordsGrid (onrecordChange)="onRecordChange($event)" [operations]="operators"
          [validationSetting]="validationSettings" [deleteRcdDialog]="deleteRecordDialog"
          (lastRecordDelete)="importId=selectedImport.id;deleteImport('yes');" [import]="selectedImport">
        </app-payroll-record>
      </div>
    </div>
  </div>
  <app-notification-loading></app-notification-loading>
</div>

<!-- CREATE IMPORT-->
<kendo-dialog title="Create Import" class="kendo-upload" [minWidth]="250" *ngIf="importOpened"
  id="create-import-dialog">
  <div [ngSwitch]="currentCloneScrn">
    <div *ngSwitchCase="1">
      <div class="text-red bottom-margin-10" id="KendoTooltip" *ngIf="isExtNotAllowed">
        <span class="k-icon k-i-error text-red"></span>The file extension "{{fileExtName}}" is not allowed
      </div>
      <kendo-upload [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" [multiple]="false" [autoUpload]="false"
        (complete)="uploadComplete($event)" [disabled]="disableClose" (upload)="uploadEventHandler($event)"
        (select)="onFileSelect($event)" (uploadProgress)="uploadProgressEventHandler($event)"
        (success)="uploadSuccess($event)" class="createImport">
        <kendo-upload-messages [select]="'Select a file...'">
        </kendo-upload-messages>
      </kendo-upload>
    </div>
    <div *ngSwitchCase="2">
      <p *ngIf="multplErrorMsg"><span class="k-icon k-i-error text-red"></span><span
          [innerHTML]="multplErrorMsg"></span></p>
      <div class="top-margin-20">
        <label class="bold">Pay Date:</label>
        <kendo-dropdownlist id="ddlOrgSelect" class="left-margin-30" [data]="scheduleSet" [textField]="'payDate'"
          [valueField]="'id'" [(ngModel)]="defaultPaySchedule"
          [popupSettings]="{ popupClass: 'nova-font-style text-black' }">
        </kendo-dropdownlist>
      </div>
      <div class="top-margin-10" *ngIf="defaultPaySchedule.payScheduleNames">
        <label class="bold">Pay Schedules with this Pay Date:</label>
        <div>
          <ul class="text-list">
            <li *ngFor="let item of defaultPaySchedule.payScheduleNames.split(',')">
              {{item}}
            </li>
          </ul>
        </div>
      </div>
      <div *ngIf="displayload" class="top-margin-7">
        <div class="stroke-separator-margin-5"></div>
        <span class="k-i-loading k-icon col-md-offset-5 kload-page"
          style="float: left;font-size: 20px;color:#dba001 !important"></span>&nbsp;
        <span class="dotLoading">Submitting</span>
        <br />
        <span>{{largeUploadMsg}}</span>
        <div class="stroke-separator-margin-5"></div>
      </div>
    </div>
  </div>
  <kendo-dialog-actions class="dialogWidth">
    <button id="closeBtn" kendoButton [disabled]="disableClose" (click)="closePopup()">Close</button>
    <button id="submitBtn" kendoButton *ngIf="currentCloneScrn === 2"
      [disabled]="disableSubmit || (multplErrorMsg && defaultPaySchedule?.id === null)"
      (click)="onFileSubmit()">Submit</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- CLONE IMPORT -->
<kendo-dialog title="Clone Import" *ngIf="cloneImportOpened" [minWidth]="345" [minHeight]="240" class="kdialog-clone app-dialog"
  id="clone-import-dialog">
  <div><strong class="bold">Clone Payroll Import :</strong> {{importId}}</div>
  <div [ngSwitch]="currentCloneScrn" class="top-margin-20">
    <div *ngSwitchCase="1">
      <div id="datePicker">
        Current PPED: <kendo-datepicker [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}" [(ngModel)]="pped"
          [value]="pped" [min]="minDate" [max]="maxDate" placeholder="MM/DD/YYYY" (valueChange)="onDateChange(pped)">
        </kendo-datepicker>
      </div>
      <div class="top-margin-1" *ngIf="!invalidPPED">
        <span class="tooltip-validation left-margin-30-percent page-bottom">
          Not a valid Date
        </span>
      </div>
      <div class="text-red top-margin-7" id="KendoTooltip" [hidden]="ppedExists">
        {{ppedCloneValidationMsg}}
      </div>
    </div>
    <div *ngSwitchCase="2">
      <p *ngIf="multplErrorMsg" id="multiple-error-msg"><span class="k-icon k-i-error text-red"></span><span
          [innerHTML]="multplErrorMsg"></span></p>
      <div class="top-margin-20">
        <label class="bold">Pay Date:</label>
        <kendo-dropdownlist id="ddlOrgSelect" class="left-margin-30" [data]="scheduleSet" [textField]="'payDate'"
          [valueField]="'id'" [(ngModel)]="defaultPaySchedule"
          [popupSettings]="{ popupClass: 'nova-font-style text-black' }">
        </kendo-dropdownlist>
      </div>
      <div class="top-margin-10" *ngIf="defaultPaySchedule.payScheduleNames">
        <label class="bold">Pay Schedules with this Pay Date:</label>
        <div>
          <ul class="text-list">
            <li *ngFor="let item of defaultPaySchedule.payScheduleNames.split(',')">
              {{item}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="displayload" class="top-margin-7">
      <div class="stroke-separator-margin-5"></div>
      <span class="k-i-loading k-icon col-md-offset-5 kload-page"
        style="float: left;font-size: 20px;color:#dba001 !important"></span>&nbsp;
      <span class="dotLoading">Cloning</span>
      <br />
      <span>{{largeUploadMsg}}</span>
      <div class="stroke-separator-margin-5"></div>
    </div>
  </div>
  <kendo-dialog-actions id="cloneImportDialogBtn">
    <button kendoButton [disabled]="displayload" (click)="close()" primary="true">Cancel</button>
    <button kendoButton [disabled]="displayload || (multplErrorMsg && defaultPaySchedule?.id === null) || !invalidPPED" primary="true"
      (click)="cloneImport(importId)">Clone</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- CONTINUE PAYROLL UPLOAD DIALOG -->
<kendo-dialog title="Continue Upload" *ngIf="maxErrorExceeded" id="continue-import-dialog"
  class="kdialog-continue app-dialog">
  <p class="important"> {{continuePayrollMsg}} </p>
  <div *ngIf="displayload">
    <div class="stroke-separator-margin-5"></div>
    <span class="k-i-loading k-icon col-md-offset-5 kload-page"
      style="float: left;font-size: 20px;color:#dba001 !important"></span>&nbsp;
    <span class="dotLoading">Uploading</span>
  </div>
  <kendo-dialog-actions id="continueUploadBtn">
    <button kendoButton [disabled]="displayload" (click)="continueUpload('no')" primary="true">No</button>
    <button kendoButton [disabled]="displayload" (click)="continueUpload('yes')" primary="true">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- SUBMIT IMPORT -->
<kendo-dialog title="Submit Import" class="app-dialog" *ngIf="displaySubmit" [width]="615" id="submit-import-dialog">
  <p id='importId'><span class="bold">Import Id :</span> {{this.selectedImport.id}} </p>

  <caption style="display:inline-block" id="cap"><em>Contribution per System, by Location</em></caption>
  <table class="submitimport" id="submitImportTable" aria-hidden="true">
    <thead id="submitImportThead">
      <tr class="subImpthead">
        <th scope="col">Location</th>
        <th scope="col"><abbr title="System">Sys</abbr></th>
        <th scope="col"><abbr title="Contribution Amount">Amount</abbr></th>
        <th scope="col"><abbr title="Member Count">Count</abbr></th>
      </tr>
    </thead>
    <tbody *ngFor="let item of result" id="submitImportTbody">
      <ng-container>
        <ng-container>
          <tr class="rowstyle" *ngFor="let dt of item.values;let i= index;">
            <td [attr.rowspan]="item.values.length" *ngIf="i===0">{{item.locationCode}}</td>
            <td class="rowCode">{{dt.systemCode}}</td>
            <td class="rowAmount">{{dt.contribution | currency:'USD':'symbol':'1.2-2'}}</td>
            <td class="rowCount">{{dt.recordCount}}</td>
          </tr>
        </ng-container>
        <tr class="total" id="amountTotal">
          <td colspan="2"><em>Total</em></td>
          <td id="amount">{{item.contTotal | currency:'USD':'symbol':'1.2-2'}}</td>
          <td id="count">{{item.rcdCount}}</td>
        </tr>
      </ng-container>
    </tbody>
    <tfoot class="gtotal">
      <tr>
        <td colspan="2">
          <span class="bold"><em>Grand Total</em></span>
        </td>
        <td class="rowAmount">{{getSum('contribution')| currency:'USD':'symbol':'1.2-2'}}</td>
        <td style="text-align: center !important;" class="rowCount">{{getSum('recordCount')}}</td>
      </tr>
    </tfoot>
  </table>
  <div *ngIf="!displayload;else loadmsg">
    <p>{{submitImportMsg}}</p>
  </div>
  <ng-template #loadmsg>
    <div class="stroke-separator-margin-5"></div>
    <div>
      <span class="k-i-loading k-icon col-md-offset-5 kload-page"
        style="float: left;font-size: 20px; color:#dba001 !important"></span>&nbsp;
      <span class="dotLoading">Submitting</span>
    </div>
    <span class="msgpop">{{largeUploadMsg}}</span>
    <div class="stroke-separator-margin-5"></div>
  </ng-template>
  <kendo-dialog-actions id="submitImportBtn">
    <button kendoButton [disabled]="displayload" (click)="submitImport('no')" id="cancelBtn" primary="true">Cancel</button>
    <button kendoButton [disabled]="displayload" (click)="submitImport('yes')" id="submitBtn"
      primary="true">Submit</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- DELETE IMPORT -->
<kendo-dialog title="Delete Import" class="app-dialog" *ngIf="importDelete" [minWidth]="250" id="delete-import-dialog">
  <p>{{deleteImportMsg}}</p>
  <div *ngIf="displayload">
    <div class="stroke-separator-margin-5"></div>
    <span class="k-i-loading k-icon col-md-offset-5 kload-page"
      style="float: left;font-size: 20px; color:#dba001 !important"></span>&nbsp;
    <span class="dotLoading">Deleting</span>
  </div>
  <kendo-dialog-actions id="deleteDialogBtn">
    <button kendoButton class="k-button" id="delete-no-btn" [disabled]="displayload"
      (click)="deleteImport('no')" primary="true">No</button>
    <button kendoButton class="k-button" id="delete-yes-btn" [disabled]="displayload" (click)="deleteImport('yes')"
      primary="true">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
